module.exports = __webpack_public_path__ + "static/media/rigo_logo.24bcd95a.png";